
import { fetchResponse, post } from "./genericFetch"
export type auth = {
    code: string;
}
export async function createAthlete(code: auth): Promise<fetchResponse<null>> {
    return await post<auth>("/api/CreateAthlete", code);
}